<div class="container-fluid py-3 py-md-4">
  <!-- Title -->
  <div class="card p-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 mb-3">
    <div>
      <h3 class="fw-bold m-0">🏠 Dashboard</h3>
      <small class="text-muted">Bird’s eye view of your business.</small>
    </div>
    <!-- (Optional) Global date filter placeholder -->
    <div class="d-flex gap-2">
      <input type="date" class="form-control form-control-sm">
      <input type="date" class="form-control form-control-sm">
      <button class="btn btn-sm btn-primary"><i class="fa-solid fa-filter me-1"></i>Apply</button>
    </div>
  </div>

  <!-- Top Row – Quick Stats -->
  <div class="row g-3 g-md-4 mb-4">
    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0  h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-primary-subtle text-primary">
            <i class="fa-solid fa-bag-shopping"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Total Courses</div>
            <div class="fw-bold fs-5">{{ stats?.totalCourses }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-success-subtle text-success">
            <i class="fa-solid fa-chart-line"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Total Internships</div>
            <div class="fw-bold fs-5">{{ stats?.totalInternships }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-info-subtle text-info">
            <i class="fa-solid fa-users"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Total Enrollments</div>
            <div class="fw-bold fs-5">{{ stats?.totalEnrollments }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-warning-subtle text-warning">
            <i class="fa-solid fa-truck-fast"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Total Applications</div>
            <div class="fw-bold fs-5">{{ stats?.totalApplications }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- second top -->
  <div class="row g-3 g-md-4 mb-4">
    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0  h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-primary-subtle text-primary">
            <i class="fa-solid fa-bag-shopping"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Enrolled Students</div>
            <div class="fw-bold fs-5">{{ stats?.enrolledStudents }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-success-subtle text-success">
            <i class="fa-solid fa-chart-line"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Pending Enrollments</div>
            <div class="fw-bold fs-5">{{ stats?.pendingEnrollments }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-info-subtle text-info">
            <i class="fa-solid fa-users"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Last 7 Days</div>
            <div class="fw-bold fs-5">{{ stats?.last7DaysEnrollments }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-warning-subtle text-warning">
            <i class="fa-solid fa-truck-fast"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Shortlisted</div>
            <div class="fw-bold fs-5">{{ stats?.shortlisted }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-warning-subtle text-warning">
            <i class="fa-solid fa-truck-fast"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Selected</div>
            <div class="fw-bold fs-5">{{ stats?.selected }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-body d-flex align-items-center gap-3">
          <div class="icon-pill bg-warning-subtle text-warning">
            <i class="fa-solid fa-truck-fast"></i>
          </div>
          <div class="flex-grow-1 text-end text-sm-start">
            <div class="small text-muted">Rejected</div>
            <div class="fw-bold fs-5">{{ stats?.rejected }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- Middle Section – Charts -->
  <!-- <div class="row g-3 g-md-4 mb-4">
    <div class="col-12 col-xl-6">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">📈 Sales Trend</div>
        <div class="card-body">
          <apx-chart [series]="salesChart.series" [chart]="salesChart.chart" [xaxis]="salesChart.xaxis"
            [dataLabels]="salesChart.dataLabels" [colors]="salesChart.colors" [legend]="salesChart.legend"
            [stroke]="salesChart.stroke">
          </apx-chart>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">💳 Payment Breakdown</div>
        <div class="card-body">
          <apx-chart [series]="paymentChart.series" [chart]="paymentChart.chart" [labels]="paymentChart.labels"
            [colors]="paymentChart.colors" [legend]="paymentChart.legend" [dataLabels]="paymentChart.dataLabels">
          </apx-chart>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">📦 Order Status</div>
        <div class="card-body">
          <apx-chart [series]="statusChart.series" [chart]="statusChart.chart" [labels]="statusChart.labels"
            [colors]="statusChart.colors" [legend]="statusChart.legend" [dataLabels]="statusChart.dataLabels">
          </apx-chart>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Top Customers -->
  <!-- <div class="card border-0 mb-4">
    <div class="card-header bg-white border-0 fw-semibold d-flex justify-content-between align-items-center">
      <span>👑 Top Customers</span>
      <a class="btn btn-sm btn-outline-secondary">View All</a>
    </div>
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>Customer</th>
            <th class="d-none d-md-table-cell">Email</th>
            <th class="text-end">Orders</th>
            <th class="text-end">Spend</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of topCustomers">
            <td>{{ c.name }}</td>
            <td class="d-none d-md-table-cell">{{ c.email }}</td>
            <td class="text-end">{{ c.orders | number }}</td>
            <td class="text-end">{{ c.spend | number }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->

  <!-- Inventory Snapshot -->
  <!-- <div class="row g-3 g-md-4 mb-4">
    <div class="col-12 col-lg-5">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">📦 Inventory Valuation</div>
        <div class="card-body">
          <div class="row text-center g-3">
            <div class="col-4">
              <div class="small text-muted">Total Qty</div>
              <div class="fw-bold fs-5">{{ inventoryValuation.totalQty | number }}</div>
            </div>
            <div class="col-4">
              <div class="small text-muted">Total Cost</div>
              <div class="fw-bold fs-5">{{ inventoryValuation.totalCost | number }}</div>
            </div>
            <div class="col-4">
              <div class="small text-muted">Retail Value</div>
              <div class="fw-bold fs-5">{{ inventoryValuation.totalRetail | number }}</div>
            </div>
          </div>
          <div class="mt-3 small text-muted">
            * Numbers are shown as plain values (no currency symbol).
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-7">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">⚠️ Low Stock Items</div>
        <div class="table-responsive">
          <table class="table table-striped align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>SKU</th>
                <th>Product</th>
                <th class="text-end">Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of lowStock">
                <td>{{ i.sku }}</td>
                <td>{{ i.name }}</td>
                <td class="text-end">{{ i.qty | number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Returns / Refunds -->
  <!-- <div class="row g-3 g-md-4 mb-4">
    <div class="col-12 col-lg-6">
      <div class="card border-0  h-100">
        <div class="card-body text-center">
          <div class="small text-muted">Returns Count</div>
          <div class="display-6 fw-bold text-primary">{{ returns.count | number }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card border-0 h-100">
        <div class="card-body text-center">
          <div class="small text-muted">Refund Amount</div>
          <div class="display-6 fw-bold text-danger">{{ returns.refundAmount | number }}</div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Bottom – Recent Activity -->
  <!-- <div class="row g-3 g-md-4">
    <div class="col-12 col-xl-7">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">🧾 Recent Orders</div>
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Order #</th>
                <th class="d-none d-lg-table-cell">Customer</th>
                <th class="text-end">Amount</th>
                <th class="d-none d-md-table-cell">Status</th>
                <th class="text-end d-none d-sm-table-cell">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of recentOrders">
                <td>{{ o.id }}</td>
                <td class="d-none d-lg-table-cell">{{ o.customer }}</td>
                <td class="text-end">{{ o.amount | number }}</td>
                <td class="d-none d-md-table-cell">
                  <span class="badge" [class.bg-secondary]="o.status==='Pending'"
                    [class.bg-primary]="o.status==='Processing'" [class.bg-success]="o.status==='Delivered'"
                    [class.bg-danger]="o.status==='Cancelled'">
                    {{ o.status }}
                  </span>
                </td>
                <td class="text-end d-none d-sm-table-cell">{{ o.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-5">
      <div class="card border-0 h-100">
        <div class="card-header bg-white border-0 fw-semibold">↩️ Recent Returns</div>
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Return #</th>
                <th class="d-none d-md-table-cell">Customer</th>
                <th class="text-end">Amount</th>
                <th class="d-none d-lg-table-cell">Reason</th>
                <th class="text-end d-none d-xl-table-cell">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of recentReturns">
                <td>{{ r.id }}</td>
                <td class="d-none d-md-table-cell">{{ r.customer }}</td>
                <td class="text-end">{{ r.amount | number }}</td>
                <td class="d-none d-lg-table-cell">{{ r.reason }}</td>
                <td class="text-end d-none d-xl-table-cell">{{ r.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div> -->
</div>